/*

    Update By POOM : 2024-05-07
      - เพิ่มการแสดงข้อมูล  cost สำหรับ จำนวนวัน * rate , ระยะทาง * rate
      
    Edit BY POOM : 09-05-2024 
      - เพิ่ม service ot เข้ามา เพราะฉนั้น ถ้าไม่มี service ot จะปิดทุกอย่างที่เกี่ยวกับ OT ออกเลย ไม่ให้บันทึกไม่ให้เห็นข้อมูล
	


*/

import React, { useEffect, useState } from "react";
import ConfigETC from "../Class/ConfigETC.json";
import { useLocation } from "react-router-dom";
import { Browser } from "@syncfusion/ej2-base";
import { CP_CheckPermission } from "../Class/Class_Permission";
import { updateSampleSection } from "../Main/Sample-base";
import {
  AccumulationChartComponent,
  AccumulationSeriesCollectionDirective,
  AccumulationSeriesDirective,
  Inject,
  AccumulationLegend,
  PieSeries,
  AccumulationTooltip,
  AccumulationDataLabel,
  ChartComponent,
  SeriesCollectionDirective,
  SeriesDirective,
  Legend,
  Category,
  StackingColumnSeries,
  Tooltip,
  Highlight,
} from "@syncfusion/ej2-react-charts";
import { Class_ETC_Decrypt } from "../Class/Class_Etc";

function PV_Overview(props) {
  const location = useLocation();

  const isSVOT = CP_CheckPermission("service_list" , ["ot"],false,false);
  const isService_department = CP_CheckPermission("service_list",["department"],false,false);
  const [isFirst, setIsFirst] = useState(true);
  const [isLoadProgress, setIsLoadProgress] = useState(true);
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [configData, setConfigData] = useState([]);
  const [pgProid, setPgProid] = useState(-1);
  const [worktime, setWorktime] = useState("-");
  const [overtime, setOvertime] = useState("-");
  const [timeoff_time, setTimeoff_time] = useState("-");
  
  const [worktime_per, setWorktime_per] = useState("-");
  const [overtime_per, setOvertime_per] = useState("-");
  const [timeoff_time_per, setTimeoff_time_per] = useState("-");

  const [time_wt_charge, setTime_wt_charge] = useState("-");
  const [time_ot_charge, setTime_ot_charge] = useState("-");

  // eslint-disable-next-line
  const [inprogressNo, setInprogressNo] = useState("0");
  const [toreviewNo, setToreviewNo] = useState("0");
  const [toapproveNo, setToapproveNo] = useState("0");
  const [approvedNo, setApprovedNo] = useState("0");
  const [rejectNo, setRejectNo] = useState("0");
  const [clearingNo, setClearingNo] = useState("0");
  const [costWT, setCostWT] = useState("0.00");
  const [costOT, setCostOT] = useState("0.00");
  const [costExpExtra, setCostExpExtra] = useState("0.00");
  const [costExpTravel, setCostExpTravel] = useState("0.00");
  const [costExpOther, setCostExpOther] = useState("0.00");
  
  const [costExpExtraDay, setCostExpExtraDay] = useState("0.00");
  const [costExpTravelDistance, setCostExpTravelDistance] = useState("0.00");

  const [dataGraphTimeSheet, setdataGraphTimeSheet] = useState([]);
  const [graphTimeSheet_Maxdate, setGraphTimeSheet_Maxdate] = useState("");
  const [graphTimeSheet_Mindate, setGraphTimeSheet_Mindate] = useState("");
  const [dataGraphCost, setdataGraphCost] = useState([]);
  const [dataGraphDepartment, setdataGraphDepartment] = useState([]);

  //#region __ Box ส่วนบน Project __
  function GetParameter(_callback) {
    let isNullParameter = false;
    let proid = "";

    try {
      if (location.state === null) {
        isNullParameter = true;
      } else {
        proid = Class_ETC_Decrypt(location.state?.proid.toString());

        if (proid === "") {
          isNullParameter = true;
        }
      }
    } catch {
      isNullParameter = true;
    }

    if (isNullParameter) {
      // ไม่ต้อง Return ตรงนี้ ให้มัน Return ที่ฝั่ง m_project_view เอา
      //window.location.replace("../" + Pathurl.m_project_view);
      if (_callback != null) {
        _callback();
      }
    } else {
      setPgProid(proid);

      if (_callback != null) {
        _callback();
      }
    }
  }
  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }
  //#endregion
  //#region Bind Data

  async function BindGraphColor(_callback) {
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        code_id: "3",
        value_status: "-1",
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Datavalue_Get",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          // Extracting value_name from each object in the data array
          json.data.forEach((item) => arrayOfColors.push(item.value_name));
          if (_callback != null) {
            _callback();
          }
        } else {
          //set ค่าเริ่มต้น
          setdataGraphCost([]);
          if (_callback != null) {
            _callback();
          }
        }
      }
      else {
        setdataGraphCost([]);
        if (_callback != null) {
          _callback();
        }
      }
    } catch {
      //set ค่าให้เป็น 0
      setdataGraphCost([]);
      if (_callback != null) {
        _callback();
      }
    }
  }

  async function BindPOVSummary(_callback) {
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        pro_id: pgProid.toString(),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Project_OV_Summary",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          setWorktime(json.data[0].work_time);
          setWorktime_per(json.data[0].work_time_per);

          setOvertime(json.data[0].over_time);
          setOvertime_per(json.data[0].over_time_per);

          setTimeoff_time(json.data[0].timeoff_time);
          setTimeoff_time_per(json.data[0].timeoff_time_per);

          setTime_wt_charge(json.data[0].time_wt_charge);
          setTime_ot_charge(json.data[0].time_ot_charge);


          setInprogressNo(json.data[0].sum_inprogress_str);
          setToreviewNo(json.data[0].sum_toreview_str);
          setToapproveNo(json.data[0].sum_toapprove_str);
          setApprovedNo(json.data[0].sum_approved_str);
          setRejectNo(json.data[0].sum_reject_str);
          setClearingNo(json.data[0].sum_clearing_str);
          setCostWT(json.data[0].sum_cost_wt_str);
          setCostOT(json.data[0].sum_cost_ot_str);
          setCostExpExtra(json.data[0].sum_cost_exp_extra_str);
          setCostExpTravel(json.data[0].sum_cost_exp_travel_str);
          setCostExpOther(json.data[0].sum_cost_exp_other_str);

          
          setCostExpExtraDay(json.data[0].sum_cost_exp_extra_day_str);
          setCostExpTravelDistance(json.data[0].sum_cost_exp_travel_distance_str);


          if (_callback != null) {
            _callback();
          }
        } else {
          //set ค่าเริ่มต้น
          ResetAllSummary();
          if (_callback != null) {
            _callback();
          }
        }
      }
      else
      {
        ResetAllSummary();
        if (_callback != null) {
          _callback();
        }
      }
    } catch {
      //set ค่าให้เป็น 0
      ResetAllSummary();
      if (_callback != null) {
        _callback();
      }
    }
  }

  async function BindPOVTimesheet(_callback) {
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        pro_id: pgProid.toString(),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Project_OV_GraphTimesheet",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          setdataGraphTimeSheet(json.data);
          setGraphTimeSheet_Mindate(json.data[0].min_ddate);
          setGraphTimeSheet_Maxdate(json.data[0].max_ddate);

          if (_callback != null) {
            _callback();
          }
        } else {
          //set ค่าเริ่มต้น

          if (_callback != null) {
            _callback();
          }
        }
      }
      else
      {
        if (_callback != null) {
          _callback();
        }
      }
    } catch {
      //set ค่าให้เป็น 0

      if (_callback != null) {
        _callback();
      }
    }
  }

  async function BindPOVCost(_callback) {
    try {
      let token = "";

      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        pro_id: pgProid.toString(),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Project_OV_GraphCost",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          setdataGraphCost(json.data);

          if (_callback != null) {
            _callback();
          }
        } else {
          //set ค่าเริ่มต้น
          setdataGraphCost([]);
          if (_callback != null) {
            _callback();
          }
        }
      }
      else
      {
        setdataGraphCost([]);
        if (_callback != null) {
          _callback();
        }
      }
    } catch {
      //set ค่าให้เป็น 0
      setdataGraphCost([]);
      if (_callback != null) {
        _callback();
      }
    }
  }

  async function BindPOVDepartment(_callback) {
    try {
      let token = "";

      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", "Bearer " + token);
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        pro_id: pgProid.toString(),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Project_OV_GraphDepartment",
        requestOptions
      );

      const json = await response.json();
      if (json.status_ID === 1) {
        if (json.total_Data > 0) {
          setdataGraphDepartment(json.data);

          if (_callback != null) {
            _callback();
          }
        } else {
          //set ค่าเริ่มต้น
          setdataGraphDepartment([]);
          if (_callback != null) {
            _callback();
          }
        }
      }
      else
      {
        setdataGraphDepartment([]);
        if (_callback != null) {
          _callback();
        }
      }
    } catch {
      //set ค่าให้เป็น 0
      setdataGraphDepartment([]);
      if (_callback != null) {
        _callback();
      }
    }
  }

  //#endregion

  //#region custom function

  function ResetAllSummary() {
    setWorktime("-");
    setWorktime_per("-");
    
    setOvertime("-");
    setOvertime_per("-");
    
    setTimeoff_time("-");
    setTimeoff_time_per("-");

    setTime_wt_charge("-");
    setTime_ot_charge("-");

    setInprogressNo(0);
    setToreviewNo(0);
    setToapproveNo(0);
    setApprovedNo(0);
    setRejectNo(0);
    setClearingNo(0);
    setCostWT("0.00");
    setCostOT("0.00");
    setCostExpExtra("0.00");
    setCostExpTravel("0.00");
    setCostExpOther("0.00");
    
    setCostExpExtraDay("0.00");
    setCostExpTravelDistance("0.00");

  }

  //#endregion

  //#region useEffect
  useEffect(() => {
    if (isFirst === true) {
      GetParameter(function () {
        GetConfig();
        if (isLoadedConfigData === true) {
          BindPOVSummary(function () {
            BindPOVTimesheet(function () {
              props.PermissionCostView && BindPOVCost(function () {});
              BindGraphColor(function () {
                BindPOVDepartment(function () {
                  setIsLoadProgress(false);
                  setIsFirst(false);
                });
              });
            });
          });
        }
        updateSampleSection();
      });
    }
    // eslint-disable-next-line
  }, [isLoadedConfigData]);

  //#endregion

  //#region Pie Chart
  // eslint-disable-next-line
  const tooltipdep = { enable: true, format: "${point.x}: ${point.tooltip}" };

  const SAMPLE_CSS = `
  .control-fluid {
      padding: 0px !important;
  }
  .pie-chart {
      align :center
  }`;
  const arrayOfColors = [];
  const onChartLoad = (args) => {
    document.getElementById("pie-chart").setAttribute("title", "");
  };
  const load = (args) => {
    //let selectedTheme = location.hash.split('/')[1];
    let selectedTheme = window.location.hash.split("/")[1];

    selectedTheme = selectedTheme ? selectedTheme : "Material";

    args.accumulation.theme = (
      selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)
    )
      .replace(/-dark/i, "Dark")
      .replace(/light/i, "Light")
      .replace(/contrast/i, "Contrast");
  };
  //#endregion

  //#region Stack Chart

  // eslint-disable-next-line
  const tooltip = { enable: true, format: "${point.tooltip}" };
  const SAMPLE_CSS2 = `
    .control-fluid {
        padding: 0px !important;
    }`;
  const onChartLoad2 = (args) => {
    let chart = document.getElementById("chartXs");
    chart.setAttribute("title", "");
  };
  const load2 = (args) => {
    let selectedTheme = window.location.hash.split("/")[1];
    selectedTheme = selectedTheme ? selectedTheme : "Material";
    args.chart.theme = (
      selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)
    )
      .replace(/-dark/i, "Dark")
      .replace(/contrast/i, "Contrast");
  };
  const axisLabelRender = (args) => {
    args.text = args.text.replace("0000000", "0M").replace("000000", "M");
  };
  //#endregion

  return (
    <>
      {/* Start Over View Detail */}

      {isLoadProgress && (
        <div
          id="divLoadingProgress"
          name="divLoadingProgress"
          align="center"
          className="divWaiting"
        >
          <img alt="progress" src="../dist/img/loading.gif" />
        </div>
      )}
      <div>
        {/* Timesheets and cost */}
        <div className="row">
          <div className="col-12 col-sm-12 col-md-9">
            <div className="row">


              <div className={(isSVOT === true ? "col-12 col-sm-12 col-md-6" : "col-12 col-sm-12 col-md-12")} >
                <div className="info-box">
                  <span className="info-box-icon bg-primary elevation-1">
                    <i className="far fa-clock" />
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">WORK TIME</span>
                    <div className="info-box-number">
                      {worktime !== "" && <>{worktime}</>}
                    </div>
                    <div className="progress">
                      <div
                        className="progress-bar bg-gray"
                        style={{ width: worktime_per + "%" }}
                      />
                    </div>
                    <span className="progress-description text-muted">
                      <span>
                        {" "}
                        {worktime_per}<small>% of Project time</small>{" "}
                      </span>
                    </span>
                  </div>
                  {/* /.info-box-content */}
                </div>
                {/* /.info-box */}
              </div>
              {/* /.col */}

              {isSVOT === true &&
                <>
                  <div className="col-12 col-sm-12 col-md-6">
                    <div className="info-box mb-3">
                      <span className="info-box-icon bg-info elevation-1">
                        <i className="far fa-lightbulb" />
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">OVER TIME</span>
                        <div className="info-box-number">
                          {overtime !== "" && <>{overtime}</>}
                        </div>
                        <div className="progress">
                          <div
                            className="progress-bar bg-gray"
                            style={{ width: overtime_per + "%" }}
                          />
                        </div>
                        <span className="progress-description text-muted">
                          <span>
                            {" "}
                            {overtime_per}<small>% of Project time</small>
                          </span>
                        </span>
                      </div>
                      {/* /.info-box-content */}
                    </div>
                    {/* /.info-box */}
                  </div>
                </>
              }


            </div>

            {/* Timesheet Cost */}
            {props.PermissionCostView && (

              <div className="row">


                <div className={(isSVOT === true ? "col-lg-6 col-6" : "col-lg-12 col-12")}>
                  {/* small box */}
                  <div className="small-box bg-primary">
                    <div className="inner">
                      <h5>
                        {costWT}
                        <small style={{ fontSize: "50%" }}>
                          <i className="fab fa-btc text-white" />
                        </small>
                        <span className="float-right">
                          <i
                            className="far fa-clock"
                            title="Only Charged tasks"
                          />{" "}
                          {time_wt_charge !== "" && <>{time_wt_charge}</>}{" "}
                        </span>
                      </h5>
                      <span className="text-small mb-0">
                        WORK TIME COST
                        <small> (Only Charged tasks)</small>
                      </span>
                    </div>
                  </div>
                </div>


                {isSVOT === true &&
                  <>
                    <div className="col-lg-6 col-6">
                      {/* small box */}
                      <div className="small-box bg-info">
                        <div className="inner">
                          <h5>
                            {costOT}
                            <small style={{ fontSize: "50%" }}>
                              <i className="fab fa-btc text-white" />
                            </small>
                            <span className="float-right">
                              <i
                                className="far fa-lightbulb"
                                title="Only Charged tasks"
                              />{" "}
                              {time_ot_charge !== "" && <>{time_ot_charge}</>}{" "}
                            </span>
                          </h5>
                          <span className="text-small mb-0">
                            OVER TIME COST
                            <small> (Only Charged tasks)</small>
                          </span>
                        </div>
                      </div>
                    </div>
                  </>
                }



              </div>
            )}

            <div className="row">
              <div className="col-12 col-sm-12 col-md-12">
                {/* Widget: user widget style 1 */}
                <div className="card card-widget widget-user">
                  {/* Add the bg color to the header using any of the bg-* classes */}
                  <div className="card-header">
                    <h6 className="widget-user-desc text-center">EXPENSES</h6>
                  </div>

                  <div className="pt-1">
                    <div className="row">
                      <div className="col-sm-4 border-right">
                        <div className="description-block">
                          <h5 className="description-header">
                            {" "}
                            {costExpExtra}
                            &nbsp;
                            <i className="fab fa-btc text-muted text-smaller" />
                          </h5>
                          <span className="description-text text-small">
                            Per diem allowances
                          </span>
                        </div>
                        {/* /.description-block */}
                      </div>
                      {/* /.col */}
                      <div className="col-sm-4 border-right">
                        <div className="description-block">
                          <h5 className="description-header">
                            {" "}
                            {costExpTravel}
                            &nbsp;
                            <i className="fab fa-btc text-muted text-smaller" />
                          </h5>
                          <span className="description-text text-small">
                            TRAVEL
                          </span>
                        </div>
                        {/* /.description-block */}
                      </div>
                      {/* /.col */}
                      <div className="col-sm-4">
                        <div className="description-block">
                          <h5 className="description-header">
                            {" "}
                            {costExpOther}
                            &nbsp;
                            <i className="fab fa-btc text-muted text-smaller" />
                          </h5>
                          <span className="description-text text-small">
                            OTHER
                          </span>
                        </div>
                        {/* /.description-block */}
                      </div>
                      {/* /.col */}
                    </div>
                    {/* /.row */}
                  </div>

                  <div className="pt-1">
                    <div className="row">
                      <div className="col-sm-4 border-right">
                        <div className="description-block">
                          <h5 className="description-header">
                            {" "}
                            {costExpExtraDay}
                            &nbsp;
                            <i className="fab fa-btc text-muted text-smaller" />
                          </h5>
                          <span className="description-text text-small">
                            Per diem allowances (day * rate)
                          </span>
                        </div>
                        {/* /.description-block */}
                      </div>
                      {/* /.col */}
                      <div className="col-sm-4 border-right">
                        <div className="description-block">
                          <h5 className="description-header">
                            {" "}
                            {costExpTravelDistance}
                            &nbsp;
                            <i className="fab fa-btc text-muted text-smaller" />
                          </h5>
                          <span className="description-text text-small">
                            TRAVEL DISTANCE (km * rate)
                          </span>
                        </div>
                        {/* /.description-block */}
                      </div>
                      {/* /.col */}
                      <div className="col-sm-4">
                      </div>
                      {/* /.col */}
                    </div>
                    {/* /.row */}
                  </div>



                </div>
                {/* /.info-box */}
              </div>
            </div>
          </div>

          <div className="col-12 col-sm-12 col-md-3">
            <div className="info-box mb-3">
              <span className="info-box-icon bg-gray elevation-1">
                <i className="far fa-pause-circle" />
              </span>
              <div className="info-box-content">
                <span className="info-box-text">TIME OFF</span>
                <span className="info-box-number">
                  {timeoff_time !== "" && <>{timeoff_time}</>}
                </span>
                <div className="progress">
                  <div
                    className="progress-bar bg-gray"
                    style={{ width: timeoff_time_per + "%" }}
                  />
                </div>
                <span className="progress-description text-muted">
                  <span>
                    {" "}
                    {timeoff_time_per}<small>% of Project time</small>
                  </span>
                </span>
              </div>
              {/* /.info-box-content */}
            </div>
            <div className="card bg-light-gray">
              <div className="card-body p-0">
                <ul className="list-group">
                  <li className="list-group-item p-2">
                    <span>REJECT</span>
                    <span className="float-right">
                      <a
                        href="#!"
                        className="btn btn-default btn-block bg-red btn-xs p-1"
                        data-toggle="pill"
                        title="Click for view detail"
                        onClick={() =>
                          props.onclick_overview_status(
                            ConfigETC.TS_Reject_Value
                          )
                        }
                      >
                        <span className="float-left p-1">
                          <i className="far fa-calendar-times" />
                        </span>
                        <span className="badge text-biger">{rejectNo}</span>
                      </a>
                    </span>
                  </li>
                  <li className="list-group-item p-2">
                    <span>to REVIEW</span>
                    <span className="float-right">
                      <a
                        href="#!"
                        className="btn btn-default btn-block bg-ToReview btn-xs p-1 col-sm-12"
                        data-toggle="pill"
                        title="Click for view detail"
                        onClick={() =>
                          props.onclick_overview_status(
                            ConfigETC.TS_ToReview_Value
                          )
                        }
                      >
                        <span className="float-left p-1">
                          <i className="fas fa-chalkboard-teacher" />
                        </span>
                        <span className="badge text-biger">
                          {toreviewNo}
                        </span>
                      </a>
                    </span>
                  </li>
                  <li className="list-group-item  p-2">
                    <span>to APPROVE</span>
                    <span className="float-right">
                      <a
                        href="#!"
                        className="btn btn-default btn-block bg-ToApprove btn-xs p-1 col-sm-12"
                        data-toggle="pill"
                        title="Click for view detail"
                        onClick={() =>
                          props.onclick_overview_status(
                            ConfigETC.TS_ToApprove_Value
                          )
                        }
                      >
                        <span className="float-left p-1">
                          <i className="fas fa-user-check" />
                        </span>
                        <span className="badge text-biger">
                          {toapproveNo}
                        </span>
                      </a>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="info-box mb-3">
              <span className="info-box-icon bg-Approved elevation-1">
                <i className="fas fa-check" />
              </span>
              <div className="info-box-content">
                <span className="info-box-text">
                  APPROVED
                  <a
                    href="#!"
                    className="text-smaller text-muted float-right align-top"
                    data-toggle="pill"
                    title="Click for view detail"
                    onClick={() =>
                      props.onclick_overview_status(
                        ConfigETC.TS_Approved_Value
                      )
                    }
                  >
                    More info <i className="fas fa-arrow-circle-right" />
                  </a>
                </span>
                <span className="info-box-number">
                  <big>{approvedNo}</big>{" "}
                  <small className="text-smaller text-muted">
                    transaction
                  </small>
                </span>
              </div>
              {/* /.info-box-content */}
            </div>

            <div className="info-box mb-3">
              <span className="info-box-icon bg-Clearing elevation-1">
                <i className="fas fa-check-double" />
              </span>
              <div className="info-box-content">
                <span className="info-box-text">
                  CLEARED
                  <a
                    href="#!"
                    className="text-smaller text-muted float-right align-top"
                    data-toggle="pill"
                    title="Click for view detail"
                    onClick={() =>
                      props.onclick_overview_status(
                        ConfigETC.TS_Clearing_Value
                      )
                    }
                  >
                    More info <i className="fas fa-arrow-circle-right" />
                  </a>
                </span>
                <span className="info-box-number">
                  <big>{clearingNo}</big>{" "}
                  <small className="text-smaller text-muted">
                    transaction
                  </small>
                </span>
              </div>
              {/* /.info-box-content */}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            {/* /.card */}
            {/* STACKED BAR CHART */}
            <div className="card">
              <div className="card-body">
                <div className="d-flex">
                  <p className="d-flex flex-column">
                    <span className="text-bold text-lg">TIMESHEET</span>
                    <span className="text-small text-muted">
                      (approved and clearing status){" "}
                    </span>
                  </p>
                </div>
                {/* /.d-flex */}
                <div className="chart">
                  <div className="control-pane">
                    <style>{SAMPLE_CSS2}</style>
                    <div className="control-section">
                      
                      <ChartComponent
                        id="chartXs"
                        style={{ textAlign: "center" }}
                        legendSettings={{
                          enableHighlight: true,
                        }}
                        primaryXAxis={{
                          majorGridLines: { width: 1 },
                          minorGridLines: { width: 0 },
                          majorTickLines: { width: 0 },
                          minorTickLines: { width: 0 },
                          interval: 1,
                          lineStyle: { width: 0 },
                          labelIntersectAction: "Rotate45",
                          valueType: "Category",
                        }}
                        primaryYAxis={{
                          title: "Days",
                          lineStyle: { width: 0 },
                          majorTickLines: { width: 0 },
                          majorGridLines: { width: 1 },
                          minorGridLines: { width: 1 },
                          minorTickLines: { width: 0 },
                          labelFormat: "{value}",
                        }}
                        width={Browser.isDevice ? "100%" : "90%"}
                        chartArea={{
                          border: { width: 0 },
                        }}
                        load={load2.bind(this)}
                        title=""
                        loaded={onChartLoad2.bind(this)}
                        tooltip={tooltip}
                        axisLabelRender={axisLabelRender.bind(this)}
                      >
                        <Inject
                          services={[
                            StackingColumnSeries,
                            Category,
                            Legend,
                            Tooltip,
                            Highlight,
                          ]}
                        />
                        <SeriesCollectionDirective>
                          <SeriesDirective
                            dataSource={dataGraphTimeSheet}
                            xName="x_timesheet_data"
                            yName="y_wt_data"
                            name="Work time"
                            columnWidth={0.6}
                            border={{
                              width: 1,
                              color: "white",
                            }}
                            type="StackingColumn"
                            fill="#3A589A"
                            tooltipMappingName="y_wt_str_data"
                          />
                          {isSVOT === true && 
                            <SeriesDirective
                              dataSource={dataGraphTimeSheet}
                              xName="x_timesheet_data"
                              yName="y_ot_data"
                              name="Over time"
                              columnWidth={0.6}
                              border={{
                                width: 1,
                                color: "white",
                              }}
                              type="StackingColumn"
                              fill="#53B7EA"
                              tooltipMappingName="y_ot_str_data"
                            />
                          }
                        </SeriesCollectionDirective>
                      </ChartComponent>
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-row justify-content-end">
                  <span>
                    <a
                      href="#!"
                      className="btn btn-default btn-sm text-small text-muted"
                      data-toggle="pill"
                      onClick={() =>
                        props.onclick_overview_TimesheetCost(
                          graphTimeSheet_Mindate,
                          graphTimeSheet_Maxdate
                        )
                      }
                    >
                      View Report
                    </a>
                  </span>
                </div>
              </div>
              {/* /.card-body */}
            </div>

            {props.PermissionCostView && (
              <div className="card">
                <div className="card-body">
                  <div className="d-flex">
                    <p className="d-flex flex-column">
                      <span className="text-bold text-lg">COST</span>
                      <span className="text-small text-muted">
                        (approved and clearing status){" "}
                      </span>
                    </p>
                  </div>
                  {/* /.d-flex */}
                  <div className="chart">
                    <div className="control-pane">
                      <style>{SAMPLE_CSS2}</style>
                      <div className="control-section">
                        <ChartComponent
                          id="chartCost"
                          style={{ textAlign: "center" }}
                          legendSettings={{
                            enableHighlight: true,
                          }}
                          primaryXAxis={{
                            majorGridLines: { width: 1 },
                            minorGridLines: { width: 0 },
                            majorTickLines: { width: 0 },
                            minorTickLines: { width: 0 },
                            interval: 1,
                            lineStyle: { width: 0 },
                            labelIntersectAction: "Rotate45",
                            valueType: "Category",
                          }}
                          primaryYAxis={{
                            title: "",
                            lineStyle: { width: 0 },
                            majorTickLines: { width: 0 },
                            majorGridLines: { width: 1 },
                            minorGridLines: { width: 1 },
                            minorTickLines: { width: 0 },
                            labelFormat: "B {value}",
                          }}
                          width={Browser.isDevice ? "100%" : "90%"}
                          chartArea={{
                            border: { width: 0 },
                          }}
                          load={load2.bind(this)}
                          title=""
                          loaded={onChartLoad2.bind(this)}
                          //tooltip={{ enable: true }}
                          tooltip={tooltip}
                          axisLabelRender={axisLabelRender.bind(this)}
                          useGroupingSeparator={true}
                        >
                          <Inject
                            services={[
                              StackingColumnSeries,
                              Category,
                              Legend,
                              Tooltip,
                              Highlight,
                            ]}
                          />
                          <SeriesCollectionDirective>
                            <SeriesDirective
                              dataSource={dataGraphCost}
                              xName="x_tc_data"
                              yName="y_tc_wt_data"
                              name="Work time"
                              columnWidth={0.6}
                              border={{
                                width: 1,
                                color: "white",
                              }}
                              type="StackingColumn"
                              fill="#3A589A"
                              tooltipMappingName="y_tc_wt_data"
                            />

                            {isSVOT === true && 
                              <SeriesDirective
                                dataSource={dataGraphCost}
                                xName="x_tc_data"
                                yName="y_tc_ot_data"
                                name="Over time"
                                columnWidth={0.6}
                                border={{
                                  width: 1,
                                  color: "white",
                                }}
                                type="StackingColumn"
                                fill="#53B7EA"
                                tooltipMappingName="y_tc_ot_data"
                              />
                            }
                            </SeriesCollectionDirective>
                        </ChartComponent>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex flex-row justify-content-end">
                    <span>
                      <a
                        href="#!"
                        className="btn btn-default btn-sm text-small text-muted"
                        data-toggle="pill"
                        onClick={() =>
                          props.onclick_overview_TimesheetCost(
                            graphTimeSheet_Mindate,
                            graphTimeSheet_Maxdate
                          )
                        }
                      >
                        View Report
                      </a>
                    </span>
                  </div>
                </div>
                {/* /.card-body */}
              </div>
            )}
          </div>
        </div>
        {isService_department && 
        <>
          <div className="row">
            {/* /.col (LEFT) */}
            <div className="col-md-12">
              {/* DONUT CHART */}
              <div className="card">
                <div className="card-body">
                  <div className="d-flex">
                    <p className="d-flex flex-column">
                      <span className="text-bold text-lg">
                        TIMESHEET by DEPARTMENT
                      </span>
                      <span className="text-small text-muted">
                        {(isSVOT === true &&
                         <>
                          (Work time & Over time Summary of approved and clearing status)
                         </>
                        )||
                        (
                         <>
                         (Work time Summary of approved and clearing status)
                        </>
                        )}
                      </span>
                    </p>
                  </div>
                  {/* /.d-flex */}
                  <div className="control-pane">
                    <style>{SAMPLE_CSS}</style>
                    <div className="control-section row">
                      <div className="col-md-12 col-sm-12 col-12 text-center">
                        <AccumulationChartComponent
                          id="pie-chart"
                          style={{ textAlign: "center" }}
                          title=""
                          load={load.bind(this)}
                          legendSettings={{ visible: true, position: "Top" }}
                          enableSmartLabels={true}
                          enableAnimation={false}
                          center={{ x: "50%", y: "50%" }}
                          enableBorderOnMouseMove={true}
                          tooltip={tooltipdep}
                          // tooltip={{
                          //   enable: true,
                          //   format:
                          //     "<b>${point.x_dept_data}</b><br> Share: <b>${point.y_ts_data}</b>",
                          //   header: "",
                          // }}
                          loaded={onChartLoad.bind(this)}
                        >
                          <Inject
                            services={[
                              AccumulationLegend,
                              PieSeries,
                              AccumulationTooltip,
                              AccumulationDataLabel,
                              Tooltip,
                            ]}
                          />
                          <AccumulationSeriesCollectionDirective>
                            <AccumulationSeriesDirective
                              dataSource={dataGraphDepartment}
                              name="Department"
                              xName="x_dept_data"
                              yName="y_ts_data"
                              explode={false}
                              explodeOffset="10%"
                              explodeIndex={0}
                              //startAngle={Browser.isDevice ? 55 : 35}
                              dataLabel={{
                                visible: false,
                                position: "Outside",
                                name: "text",
                                font: { fontWeight: "600" },
                                connectorStyle: {
                                  length: "20px",
                                  type: "Curve",
                                },
                              }}
                              radius={Browser.isDevice ? "40%" : "70%"}
                              innerRadius="50%"
                              palettes={arrayOfColors}
                              tooltipMappingName="y_ts_str_data"
                            />
                          </AccumulationSeriesCollectionDirective>
                        </AccumulationChartComponent>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex flex-row justify-content-end">
                    <span>
                      <a
                        href="#!"
                        data-toggle="pill"
                        onClick={() =>
                          props.onclick_overview_TimesheetDepartment()
                        }
                        title="Click for view detail"
                        className="btn btn-default btn-sm text-small text-muted"
                      >
                        View Report
                      </a>
                    </span>
                  </div>
                </div>
                {/* /.card-body */}
              </div>
              {/* /.card */}
            </div>
            {/* /.col (RIGHT) */}
          </div>
        </>
        }

        {/* /.row */}
      </div>
    </>
  );
}

export default PV_Overview;
